export default "__VITE_ASSET__CvpioYq7__"